<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
window.onload = function () {
  document.addEventListener("touchstart", function (event) {
    if (event.touches.length > 1) {
      event.preventDefault();
    }
  });
  document.addEventListener("gesturestart", function (event) {
    event.preventDefault();
  });
};
export default {
  name: "App",
};
</script>

<style>
@import "assets/css/base.css";
@import "assets/css/font.css"; /* 通常将样式在这里导入，优先渲染 */
</style>
